var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-container"},[_c('div',{staticClass:"load"},[(_vm.hasMore)?_c('span',{staticClass:"el-icon-loading load-icon"}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.hasMore ? "正在加载中..." : "没有更多数据了"))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }